<template>
  <div class="main">
    <Header :show="show" @listenEvent="fn" @listenHeight="getHeight" />
    <div
      class="imgshowbox"
      @click="changeShow"
      :style="'margin-top:' + msgboxTop + 'px'"
    >
      <div class="container">
        <img class="titleimg" src="../assets/images/topImg/5.jpg" alt="" />
        <div class="title-box">
          <div class="title-box-bottom">
            <h3 class="big-title">AI智能消费类产品</h3>
            <p class="title-details">
              以家庭为中心，依托视频、音频、
              智能分析等技术，为用户提供家庭视频监控、智能家居等互联网产品。用科技的力量，让每一个人、每一个家庭都能享受到便捷有趣、安全舒适、充满关爱的智能生活。
            </p>
            <van-button
              v-show="showVideo"
              round
              class="title-box-bottom-video"
              @click="
                () => {
                  this.$router.push({
                    name: 'video',
                    query: {
                      src: 'static/video/Homevideosolutions.mp4'
                    }
                  });
                }
              "
            >
              <van-icon :name="require('../assets/images/play.png')" />
              <span>家用视频解决方案</span>
            </van-button>
          </div>
        </div>
      </div>
      <div>
        <van-tabs v-model="active" swipeable animated>
          <van-tab
            v-for="item in messageList"
            :key="item.id"
            :title="item.title"
          >
            <div class="product-box">
              <div class="product-box-top">
                <p class="product-title">
                  {{ item.details }}
                </p>

                <div class="product-button">
                  <span v-for="list in item.buttonList" :key="list.id">
                    <router-link
                      :to="{ path: list.url, query: { src: list.src } }"
                    >
                      <van-button
                        class="title-box-bottom-video change-color"
                        round
                        ><van-icon :name="list.icon"></van-icon>
                        <span class="button-in-box">{{ list.text }}</span>
                      </van-button>
                    </router-link>
                  </span>
                </div>
              </div>

              <div
                class="product-box-middle"
                v-for="article in item.articleList"
                :key="article.id"
              >
                <div class="img-box">
                  <van-image width="100%" fit="contain" :src="article.src" />

                  <div>
                    <h4>{{ article.articletitle }}</h4>
                    <span class="product-details"
                      >{{ article.articledetails }}
                    </span>
                    <div v-for="list in article.traitList" :key="list.id">
                      <h5>{{ list.lightTitle }}</h5>
                      <p v-for="(light, index) in list.lightList" :key="index">
                        {{ light.light }}
                      </p>
                    </div>
                  </div>
                  <p class="linkmore" v-show="article.have">
                    <a :href="article.href">了解更多>>></a>
                  </p>
                </div>
              </div>
            </div>
          </van-tab>
        </van-tabs>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
export default {
  components: { Header },
  data() {
    return {
      src: "/video",
      show: false,
      active: 0,
      showVideo: true,
      msgboxTop: 0,

      messageList: [
        {
          id: 1,
          title: "入户门禁",
          details: "",
          buttonList: [
            // {
            //   id: 1 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 1 - 3,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 1 - 1 - 2,
              src: require("../assets/images/product/P26920580Kling.jpg"),
              articletitle: "小K智能可视门铃",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 2,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "超低功耗，超长待机，智能节电"
                    },
                    {
                      light:
                        "具备防拆报警，设备被异常拆除发出报警声，并推送报信息至用户手机"
                    },
                    {
                      light: "内置4000mAh锂电池，超待机长，充电方便"
                    },
                    {
                      light: "内置PIR人体红外感应，门前有人徘徊即时推送警报消息"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    }
                  ]
                }
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 1 - 1 - 3,
              src: require("../assets/images/product/P27920580Yling.jpg"),
              articletitle: "小圆全景智能可视门铃",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 3,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "超低功耗，超长待机，智能节电"
                    },
                    {
                      light: "全玻璃鱼眼镜头，360°VR全景视野"
                    },
                    {
                      light: "3节5号干电池供电，更换方便"
                    },
                    {
                      light: "内置PIR人体红外感应，门前有人徘徊即时推送警报消息"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    }
                  ]
                }
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 1 - 1 - 4,
              src: require("../assets/images/product/P28920580Dling.jpg"),
              articletitle: "小叮全景智能可视门铃",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 4,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "超低功耗，超长待机，智能节电"
                    },
                    {
                      light: "全玻璃鱼眼镜头，180°VR全景视野"
                    },
                    {
                      light: "采用2节18650可充电锂电池供电，易拆装，可更换电池"
                    },
                    {
                      light: "内置PIR人体红外感应，门前有人徘徊即时推送警报消息"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    }
                  ]
                }
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 1 - 1 - 5,
              src: require("../assets/images/product/P29920580eye.jpg"),
              articletitle: "智能可视猫眼",
              articledetails: "",
              traitList: [
                {
                  id: 1 - 1 - 1 - 5,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "超低功耗，超长待机，智能节电"
                    },
                    {
                      light: "内置8000mAh锂电池，超待机长，充电方便"
                    },
                    {
                      light:
                        "4.3英寸显示屏，有人按铃自动亮起并显示门外实时画面，不用担心小孩看不到，老人看不清"
                    },
                    {
                      light: "内置PIR人体红外感应，门前有人徘徊即时推送警报消息"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    }
                  ]
                }
                // {
                //   id: 1 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            }
          ]
        },
        {
          id: 2,
          title: "视频看护",
          details: "",
          buttonList: [
            // {
            //   id: 2 - 1,
            //   icon: require("../assets/images/play.png"),
            //   text: "播放视频1",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // },
            // {
            //   id: 2 - 2,
            //   icon: require("../assets/images/ppt.png"),
            //   text: "播放视频3",
            //   url: "/video",
            //   src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
            // }
          ],
          articleList: [
            {
              id: 2 - 1 - 1,
              src: require("../assets/images/product/P30920580Zcamera.jpg"),
              articletitle: "小智室内云台摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 1,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "智能区域警戒，贵重物品重点看护"
                    },
                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "双电机云台控制旋转，环视全景看护"
                    },
                    {
                      light: "一键定点巡航，重点区域巡航查看"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light:
                        "多种安装方式（吊装、壁装、摆放），满足不同场景需求"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },

            {
              id: 2 - 1 - 3,
              src: require("../assets/images/product/P31920580Xcamera.jpg"),
              articletitle: "大雄室内云台摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 3,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "智能区域警戒，贵重物品重点看护"
                    },
                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "双电机云台控制旋转，环视全景看护"
                    },
                    {
                      light: "一键定点巡航，重点区域巡航查看"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light:
                        "多种安装方式（吊装、壁装、摆放），满足不同场景需求"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 4,
              src: require("../assets/images/product/P32920580Pcamera.jpg"),
              articletitle: "大朋室内云台摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 4,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "智能区域警戒，贵重物品重点看护"
                    },
                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "双电机云台控制旋转，环视全景看护"
                    },
                    {
                      light: "一键定点巡航，重点区域巡航查看"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light:
                        "多种安装方式（吊装、壁装、摆放），满足不同场景需求"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 13,
              src: require("../assets/images/product/P44920580Tcamera.jpg"),
              articletitle: "小兔看护摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 13,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI智能跌倒/哭声检测，时刻守护老人孩子"
                    },
                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，设备掉线也能查看历史录像"
                    },
                    {
                      light:
                        "可弯曲支架，安装随心所欲，支持挂墙、直立桌面、缠绕等安装方式"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 5,
              src: require("../assets/images/product/P33920580Hcamera.jpg"),
              articletitle: "海螺型摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 5,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "语音和白光双重报警，有效震慑入侵者"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 6,
              src: require("../assets/images/product/P34920580Fcamera.jpg"),
              articletitle: "飞碟型摄像机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 6,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "移动侦测报警，报警推送，异常情况实时掌握"
                    },
                    {
                      light: "超强红外夜视，夜晚也能一目了然"
                    },

                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "全玻璃鱼眼镜头，360°VR全景视野"
                    },

                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 7,
              src: require("../assets/images/product/P35920580EG.jpg"),

              articletitle: "EG室外防水枪机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 7,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "周界警戒，重点区域重点看护"
                    },

                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "语音和白光双重报警，有效震慑入侵者"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light: "支持无线和有线连接"
                    },
                    {
                      light: "IP66防水等级，风雨无惧"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 8,
              src: require("../assets/images/product/P36920580EL.jpg"),
              articletitle: "EL室外防水枪机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 8,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "周界警戒，重点区域重点看护"
                    },

                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "语音和白光双重报警，有效震慑入侵者"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light: "支持无线和有线连接"
                    },
                    {
                      light: "IP66防水等级，风雨无惧"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },

            {
              id: 2 - 1 - 9,
              src: require("../assets/images/product/P37920580EHA.jpg"),

              articletitle: "EHA室外防水枪机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 9,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "周界警戒，重点区域重点看护"
                    },

                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "语音和白光双重报警，有效震慑入侵者"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light: "支持无线和有线连接"
                    },
                    {
                      light: "IP66防水等级，风雨无惧"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            },
            {
              id: 2 - 1 - 11,
              src: require("../assets/images/newAdd/44.jpg"),

              articletitle: "MD室外防水球机",
              articledetails: "",
              traitList: [
                {
                  id: 2 - 1 - 1 - 11,
                  lightTitle: "产品特点",
                  lightList: [
                    {
                      light: "AI人形检测，过滤无效报警，提高报警质量"
                    },
                    {
                      light: "周界警戒，重点区域重点看护"
                    },

                    {
                      light: "手机报警推送，异常报警实时掌握"
                    },
                    {
                      light: "语音和白光双重报警，有效震慑入侵者"
                    },
                    {
                      light: "双电机云台控制旋转，环视全景看护"
                    },
                    {
                      light: "可自定义个性化语音提示，迎宾防盗都合适"
                    },
                    {
                      light: "双向语音通话，远距离沟通无障碍"
                    },
                    {
                      light: "支持TF卡存储，循环录像"
                    },
                    {
                      light: "支持云存储，录像不丢失，偷不走，砸不坏"
                    },
                    {
                      light: "支持无线和有线连接"
                    },
                    {
                      light: "IP66防水等级，风雨无惧"
                    }
                  ]
                }
                // {
                //   id: 2 - 1 - 1 - 2,
                //   lightTitle: "适用场景",
                //   lightList: [
                //     {
                //       light:
                //         "广泛应用于咖啡厅，面包店，服饰店，便利店，宠物店等多种监控应用场景"
                //     }
                //   ]
                // }
              ],
              have: true,
              href:
                "https://xiongmai.tmall.com/?spm=a220o.1000855.1997427721.d4918089.17672ab8JZ1TRy"
            }
          ]
        }
        // {
        //   id: 4,
        //   title: "AI智能算法",
        //   details: "暂无内容"
        //   // buttonList: [
        //   //   {
        //   //     id: 4 - 1,
        //   //     icon: require("../assets/images/play.png"),
        //   //     text: "播放视频1",
        //   //     url: "/video",
        //   //     src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
        //   //   },

        //   //   {
        //   //     id: 4 - 3,
        //   //     icon: require("../assets/images/ppt.png"),
        //   //     text: "播放视频3",
        //   //     url: "/video",
        //   //     src: "http://clips.vorwaerts-gmbh.de/big_buck_bunny.mp4"
        //   //   }
        //   // ],
        //   // articleList: [
        //   //   {
        //   //     id: 4 - 1 - 1,
        //   //     src: "https://img01.yzcdn.cn/vant/cat.jpeg",
        //   //     articletitle: "老人看护",
        //   //     articledetails:
        //   //       "AI智能摄像机搭配AI智能跌倒检测，老人跌倒自动识别，并推送消息至子女手机，即时在外工作，也能及时了解家中老人安全，遇到突发事件，第一时间处理。",
        //   //     // traitList: [
        //   //     //   {
        //   //     //     id: 4 - 1 - 1 - 1,
        //   //     //     lightTitle: "产品特点",
        //   //     //     lightList: [
        //   //     //       {
        //   //     //         light: "H.265+/H.265/H.264视频压缩技术"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "云存储"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "零延时，传输距离达到500米以上"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "AI智能人脸检测，AI智能人形检测"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "手机短视频报警推送"
        //   //     //       }
        //   //     //     ]
        //   //     //   },
        //   //     //   {
        //   //     //     id: 1 - 1 - 1 - 2,
        //   //     //     lightTitle: "适用场景",
        //   //     //     lightList: [
        //   //     //       {
        //   //     //         light:
        //   //     //           "广泛应用于学校，工厂，超市，便利店，宠物店等多种监控应用场景"
        //   //     //       }
        //   //     //     ]
        //   //     //   }
        //   //     // ],
        //   //     href: "http://www.jufenginfo.com/product-list-432-312.html"
        //   //   },
        //   //   {
        //   //     id: 4 - 1 - 2,
        //   //     src: "https://img01.yzcdn.cn/vant/cat.jpeg",
        //   //     articletitle: "婴儿看护",
        //   //     articledetails:
        //   //       "AI智能摄像机搭配AI智能哭声检测，自动识别婴儿哭声，并推送消息至父母手机，看护宝宝更方便。",
        //   //     // traitList: [
        //   //     //   {
        //   //     //     id: 4 - 1 - 1 - 1,
        //   //     //     lightTitle: "产品特点",
        //   //     //     lightList: [
        //   //     //       {
        //   //     //         light: "H.265+/H.265/H.264视频压缩技术"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "云存储"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "零延时，传输距离达到500米以上"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "AI智能人脸检测，AI智能人形检测"
        //   //     //       },
        //   //     //       {
        //   //     //         light: "手机短视频报警推送"
        //   //     //       }
        //   //     //     ]
        //   //     //   },
        //   //     //   {
        //   //     //     id: 1 - 1 - 1 - 2,
        //   //     //     lightTitle: "适用场景",
        //   //     //     lightList: [
        //   //     //       {
        //   //     //         light:
        //   //     //           "广泛应用于学校，工厂，超市，便利店，宠物店等多种监控应用场景"
        //   //     //       }
        //   //     //     ]
        //   //     //   }
        //   //     // ],
        //   //     href: "http://www.jufenginfo.com/product-list-432-312.html"
        //   //   }
        //   // ]
        // }
      ]
    };
  },

  methods: {
    changeShow() {
      this.show = false;
    },
    fn(val) {
      this.show = val;
    },
    getHeight(val) {
      this.msgboxTop = val;
    }
  },
  watch: {
    msgboxTop(val) {
      this.msgboxTop = val;
    }
  }
};
</script>

<style></style>
